import React from "react";
import PropTypes from "prop-types";
import { Empty } from "antd";

// Safety cap so a huge sheet can't lock the browser; the rest is downloadable.
const MAX_ROWS = 2000;

// Spreadsheet-style column label: 0 -> A, 25 -> Z, 26 -> AA ...
function colName(index) {
    let n = index + 1;
    let label = "";
    while (n > 0) {
        const rem = (n - 1) % 26;
        label = String.fromCharCode(65 + rem) + label;
        n = Math.floor((n - 1) / 26);
    }
    return label;
}

/**
 * Renders parsed Excel/CSV sheets (array-of-arrays per sheet) as a read-only,
 * spreadsheet-style table with a tab per sheet. Keeps the file inline instead of
 * forcing a browser download.
 */
class ExcelView extends React.Component {
    state = { active: 0 };

    setActive = index => this.setState({ active: index });

    render() {
        const { sheets } = this.props;
        if (!sheets || !sheets.length) {
            return (
                <div className={"cc-docviewer--empty"}>
                    <Empty description={"Empty workbook"} />
                </div>
            );
        }
        const active = Math.min(this.state.active, sheets.length - 1);
        const sheet = sheets[active] || { rows: [] };
        const rows = sheet.rows || [];
        const capped = rows.slice(0, MAX_ROWS);
        const cols = capped.reduce((max, row) => Math.max(max, row.length), 0);
        const colIdx = Array.from({ length: cols });

        return (
            <div className={"cc-xls"}>
                {sheets.length > 1 ? (
                    <div className={"cc-xls__tabs"}>
                        {sheets.map((s, i) => (
                            <button
                                type={"button"}
                                key={s.name + i}
                                className={
                                    "cc-xls__tab" +
                                    (i === active ? " cc-xls__tab--on" : "")
                                }
                                onClick={() => this.setActive(i)}
                            >
                                {s.name}
                            </button>
                        ))}
                    </div>
                ) : null}
                <div className={"cc-xls__scroll"}>
                    <table className={"cc-xls__table"}>
                        <thead>
                            <tr>
                                <th className={"cc-xls__corner"} />
                                {colIdx.map((_, c) => (
                                    <th key={c}>{colName(c)}</th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {capped.map((row, ri) => (
                                <tr key={ri}>
                                    <td className={"cc-xls__rownum"}>{ri + 1}</td>
                                    {colIdx.map((_, c) => (
                                        <td key={c}>
                                            {row[c] !== null &&
                                            row[c] !== undefined
                                                ? String(row[c])
                                                : ""}
                                        </td>
                                    ))}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                {rows.length > MAX_ROWS ? (
                    <div className={"cc-xls__note"}>
                        Showing first {MAX_ROWS} of {rows.length} rows — use
                        download for the full file.
                    </div>
                ) : null}
            </div>
        );
    }
}

ExcelView.propTypes = {
    sheets: PropTypes.array
};

export default ExcelView;
